// extracted by mini-css-extract-plugin
module.exports = {"nav_list":"navlinks_nav_list__bN0qi","navl_list_footer":"navlinks_navl_list_footer__26o7X","hidden":"navlinks_hidden__2igj4"};